import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-link text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-background-50 text-base">
                17c入口导航
              </span>
            </div>
            <p className="text-secondary-400 text-sm leading-relaxed">
              提供最准确、最及时的17c com入口导航服务，安全稳定，体验流畅。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">首页</Link></li>
              <li><Link to="/category/access-guide" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">访问指南</Link></li>
              <li><Link to="/category/problem-solution" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">问题解决</Link></li>
              <li><Link to="/category/latest-news" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">最新动态</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
              帮助中心
            </h4>
            <ul className="flex flex-col gap-2">
              <li><Link to="/category/faq" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">常见问答</Link></li>
              <li><Link to="/category/security-tips" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">安全贴士</Link></li>
              <li><Link to="/about" className="text-secondary-400 hover:text-background-50 text-sm transition-colors">关于我们</Link></li>
              <li><a href={`mailto:${siteConfig.brand.contact.email}`} className="text-secondary-400 hover:text-background-50 text-sm transition-colors">联系我们</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 text-sm mb-4">
              联系方式
            </h4>
            <ul className="flex flex-col gap-2 text-secondary-400 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteConfig.brand.contact.email}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{siteConfig.brand.contact.phone}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line"></i>
                <span>{siteConfig.brand.contact.wechat}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="py-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-secondary-500 text-xs">
            &copy; {currentYear} {siteConfig.brand.name} 版权所有 | 本站为非官方第三方导航网站
          </p>
          <div className="flex items-center gap-4 text-secondary-500 text-xs">
            <a href="#" className="hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-50 transition-colors">服务条款</a>
            <a href="#" className="hover:text-background-50 transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}